// removed by extract-text-webpack-plugin
module.exports = {"component":"gIzAxuhs5hFxanjHPgzb7","js_ul":"_3ZUSOiZZfvuAemAPk_PWnv","js_li":"_38lsls2yBU-71303fGiA-R","border":"_2TPyTRpsvYLUeHyYFLSyoe","bk_zs_link":"_1RIlmJD7BNpzGtvwsPmIOo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/EncyclopedicKnowledge/EnyclopedicKnowledge.scss
 ** module id = 1058
 ** module chunks = 0
 **/